import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import PolicyContainer from "../containers/policy";
import NewsletterArea from "../containers/global/newsletter";
import PageBanner from "../containers/global/page-banner";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";

const PrivacyPolicyPage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="BunnySpire LLC – Privacy Policy" />
                <div className="wrapper">
                    <Header />
                    <PageBanner
                        title="Privacy Policy"
                        excerpt="Effective Date: 08-17-2023"
                        image="./images/faq/1.png"
                    />
                    <PolicyContainer />
                    <NewsletterArea />
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default PrivacyPolicyPage;
